export function savReducer(state = {
    WAITING : {},
    IN_REPAIR : {},
    REPAIRED : {},
    BACK_IN_STOCK : {},
    HS : {},
    ALL: {}
},{
    type,
    payload
}){
    
    switch(type){
        case "ADD_SAV":
            let newState = Object.assign({}, state)

            newState.ALL[payload.id] = payload // add in new list
            newState[payload.sav_last_status][payload.id] = payload // add in new status

            return newState
        case "UPDATE_SAV":
            let newState2 = Object.assign({}, state)
            const { oldStatus, sav } = payload;
            console.log('====================================');
            console.log({payload});
            console.log('====================================');
            newState2.ALL[sav.id] = sav // add in new list
            delete newState2[oldStatus][sav.id] // delete from old status
            newState2[sav.sav_last_status][sav.id] = sav // add in new status

            return newState2

        case "GET_SAVS":
            return payload
        default:
            return state;
    }
    
}